
const PrivacyPolicy = () => (
  <>
    <main className="pt-32 lg:pt-28 pb-16">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-2">Privacy Policy</h1>
        <p className="text-muted-foreground text-sm mb-8">Last updated: April 10, 2026</p>

        <div className="prose prose-neutral max-w-none space-y-6 text-foreground/90 leading-relaxed">
          <section>
            <h2 className="text-xl font-heading font-bold text-foreground mt-8 mb-3">1. Information We Collect</h2>
            <p>We may collect the following types of information when you visit our website, request an estimate, or contact us:</p>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li><strong className="text-foreground">Personal Information:</strong> Name, email address, phone number, mailing address, and other details you provide through our forms.</li>
              <li><strong className="text-foreground">Usage Data:</strong> IP address, browser type, pages visited, time spent on pages, and referring URLs.</li>
              <li><strong className="text-foreground">Communications:</strong> Records of correspondence if you contact us via email, phone, or our website chat.</li>
            </ul>
          </section>
          <section>
            <h2 className="text-xl font-heading font-bold text-foreground mt-8 mb-3">2. How We Use Your Information</h2>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>Respond to your inquiries and provide estimates</li>
              <li>Deliver and improve our roofing and exterior services</li>
              <li>Send service-related communications</li>
              <li>Improve our website and user experience</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>
          <section>
            <h2 className="text-xl font-heading font-bold text-foreground mt-8 mb-3">3. Information Sharing</h2>
            <p className="text-muted-foreground">We do not sell, trade, or rent your personal information to third parties. We may share information with trusted service providers who assist us in operating our website and conducting our business.</p>
          </section>
          <section>
            <h2 className="text-xl font-heading font-bold text-foreground mt-8 mb-3">4. Cookies & Tracking</h2>
            <p className="text-muted-foreground">Our website uses cookies and similar tracking technologies to enhance your browsing experience and analyze site traffic.</p>
          </section>
          <section>
            <h2 className="text-xl font-heading font-bold text-foreground mt-8 mb-3">5. Data Security</h2>
            <p className="text-muted-foreground">We implement reasonable security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction.</p>
          </section>
          <section>
            <h2 className="text-xl font-heading font-bold text-foreground mt-8 mb-3">6. Contact Us</h2>
            <p className="text-muted-foreground">If you have questions about this Privacy Policy, please contact us at:</p>
            <p className="text-muted-foreground mt-2">
              <strong className="text-foreground">Kodiak Structures & Exteriors</strong><br />
              Phone: (651) 983-1609
            </p>
          </section>
        </div>
      </div>
    </main>
  </>
);

export default PrivacyPolicy;
